import React from 'react';
import MuiAlert from '@material-ui/lab/Alert';
import { formatRecentTime } from '../../../helper/uiFunctions';

const LiveNotifyToast = React.forwardRef((props, ref) => {
    const { notification, onClose, onOpen } = props;
    const toastTime = formatRecentTime(notification?.createdOn);

    return (
        <MuiAlert
            ref={ref}
            elevation={6}
            variant="filled"
            severity="info"
            onClose={onClose}
            style={{
                cursor: 'pointer',
                alignItems: 'center',
                minWidth: '320px',
                maxWidth: '320px',
                minHeight: '64px',
                maxHeight: '64px',
                boxSizing: 'border-box'
            }}
            onClick={onOpen}
        >
            <div style={{ width: '100%', minWidth: 0 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', width: '100%' }}>
                    <div style={{
                        fontWeight: 700,
                        minWidth: 0,
                        flex: 1,
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        lineHeight: 1.3
                    }}>
                        {notification?.title || 'Notification'}
                    </div>
                    {toastTime && (
                        <div style={{
                            fontSize: '0.75rem',
                            lineHeight: 1,
                            whiteSpace: 'nowrap',
                            color: 'rgba(255,255,255,0.82)',
                            marginLeft: 'auto',
                            textAlign: 'right'
                        }}>
                            {toastTime}
                        </div>
                    )}
                </div>
            </div>
        </MuiAlert>
    );
});

export default LiveNotifyToast;
